var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer"},[_c('p',{staticClass:"commons"},[_vm._v("© 2020 Anderson Pozzi. All rights reserved.")]),_c('p',{staticClass:"credit"},[_vm._v("Developed with Vue.js")])])
}]

export { render, staticRenderFns }